<style scoped lang="sass">
.title
  font-weight: 700
  margin-bottom: 0.5rem
.suggestions
  .suggestion
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: 0.25rem
    .name
      margin-right: 0.5rem
    .button
      margin-top: 0
      font-size: 0.8rem
      padding: 0.25rem 0.5rem
.changes
  font-size: 0.75rem
  >*
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: 1rem
    >img
      width: 15px
      height: 15px
      cursor: pointer
</style>
<template>
  <div>
    <div class="title">Invite Your Friends</div>
    <form @submit.prevent="submit">
      <div class="input-group">
        <label>SEARCH</label>
        <input type="text" v-model="search" placeholder="Type name or email" class="input-control">
      </div>
      <div class="suggestions">
        <div v-for="({name, email}) in contacts" class="suggestion" :key="email">
          <span class="name ellipsis-overflow">{{suggestionDisplayName({name,email})}}</span>
          <button @click.prevent="addParticipation({name, email})" class="button positive inline">Add</button>
        </div>
      </div>
      <div v-if="suggestions.length" class="input-group">
        <label>ADD EVERYONE FROM A PREVIOUS POOL</label>
        <pinhigh-select
            :options="suggestionOptions"
            :on-select="selectPreviousPool"
            ></pinhigh-select>
      </div>
      <div v-if="adjustingParticipations.length" class="input-group">
        <label>CHANGES</label>
        <div class="changes">
          <div v-for="(adjustment, index) in adjustingParticipations" :key="adjustment.email">
            {{adjustment.action === 'add' ? 'Adding' : 'Removing'}} {{adjustment.name || adjustment.email}}
            <img
              :src="require('../../assets/images/icon-cancel.png')"
              @click.prevent="undoAdjustment({index})"
              />
          </div>
        </div>
      </div>
      <div v-if="pool.participations && pool.participations.length" class="input-group">
        <label>PREVIOUSLY INVITED</label>
        <div class="changes">
          <div v-for="participation in pool.participations" :key="participation.email">
            {{participation.awaiting === 'user' ? 'Awaiting' : 'Accepted by'}} {{participation.user ? participation.user.short_informal_name : participation.email}}
            <img
              :src="require('../../assets/images/icon-cancel.png')"
              @click.prevent="removeParticipation(participation)"
              />
          </div>
        </div>
      </div>
      <div>
        <input type="submit" value="Finish: Send Invites" class="button positive">
      </div>
    </form>
  </div>
</template>
<script>
import _ from 'lodash';
import Vuex from 'vuex';

import api from '../../api';

export default {
  name: 'Invite',
  props: {
    goToStep: {
      type: Function,
      required: true
    }
  },
  created() {
    if (this.isPoolNew) {
      this.$store.dispatch('poolForm/addAdjustingParticipation', {email: this.$root.currentUser.email, name: this.$root.currentUser.short_informal_name, action: 'add'});
    }
    api.PoolParticipationSuggestion.index().then(suggestions => {
      this.suggestions = suggestions;
    });
  },
  data() {
    return {
      search: '',
      contacts: [],
      suggestions: []
    };
  },
  computed: {
    ...Vuex.mapGetters('poolForm', ['pool', 'isPoolNew']),
    suggestionOptions() {
      return this.suggestions.map(({name},index) => ({label: name, value: index}));
    },
    adjustingParticipations() {
      return this.pool.adjusting_participations;
    }
  },
  methods: {
    submit() {
      this.goToStep({pool: this.localPool, step: null});
    },
    capitalize(value) {
      return _.capitalize(value);
    },
    addParticipation({name, email}) {
      this.$store.dispatch('poolForm/addAdjustingParticipation', {name, email, action: 'add'});
      this.search = '';
    },
    removeParticipation(participation) {
      this.$store.dispatch('poolForm/addAdjustingParticipation', {name: participation.user ? participation.user.short_informal_name : participation.email, email: participation.email, action: 'remove'});
    },
    undoAdjustment({index}) {
      this.$store.dispatch('poolForm/removeAdjustingParticipation', index);
    },
    selectPreviousPool(index) {
      this.suggestions[index].values.forEach(({email, name}) => {
        this.$store.dispatch('poolForm/addAdjustingParticipation', {name, email, action: 'add'});
      });
    },
    suggestionDisplayName({name,email}) {
      if (name) {
        return `${name} (${email})`;
      } else {
        return email;
      }
    }
  },
  watch: {
    search: _.debounce(function(value) {
      Promise.all([
        // Suggest past participants
        new Promise(resolve => {
          if (value && value.length > 1) {
            api.ParticipationSuggestion.index({params: {search: value}})
              .then(suggestions => resolve(suggestions));
          } else {
            resolve([]);
          }
        }),
        // If the search is an email address
        new Promise(resolve => {
          if (value.match(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9\-.]+$/)) {
            resolve([{email: value}]);
          } else {
            resolve([]);
          }
        }),
        // Retrieve contact emails
        new Promise((resolve) => {
          if (navigator.contacts) {
            navigator.contacts.find(
              [navigator.contacts.fieldType.displayName, navigator.contacts.fieldType.name, navigator.contacts.fieldType.emails],
              contacts => {
                resolve(
                  contacts
                    .filter(({emails}) => emails.length)
                    .reduce((memo, {name: {formatted: name}, emails}) => {
                      emails.forEach(({value: email}) => memo.push({name, email}));
                      return memo;
                    }, [])
                );
              },
              () => resolve([]),
              {filter: value, desiredFields: [navigator.contacts.fieldType.name, navigator.contacts.fieldType.emails]}
            );
          } else {
            resolve([]);
          }
        })
      ]).then(contactGroups => {
        this.contacts = [].concat(...contactGroups);
      });
    })
  }
};
</script>
